import React, {Fragment, useEffect, useRef, useState} from "react";
import moment from 'moment'
import PropTypes from "prop-types";
import {connect, useDispatch, useSelector} from "react-redux";
import CustomPagination from "../layout/CustomPagination";
import SearchForm from "../layout/SearchForm";
import FilterByMonth from "../layout/FilterByMonth";
import FilterByFirm from "../suppliers_material_transactions/FilterByFirm";
import MaterialDataRow from "./MaterialDataRow";
import {getMaterialsTransactions, updateTransaction} from "../../actions/materials_transaction";
import MaterialReport from "./MaterialReport";

//create your forceUpdate hook
function useForceUpdate() {
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}

const MaterialCalculations = (props) => {

    // const dispatch = useDispatch();
    const forceUpdate = useForceUpdate();

    const resetAllRows = (e) => {

        forceUpdate();
    }
    const {
        auth
    } = useSelector(state => state);

    const {role_name} = auth?.user || {};

    const {
        dates,
        materials,
        loading,
        numberOfPages,
        current_page,
    } = useSelector(state => state.materials_transaction);

    const scrollableContainer = useRef();
    const [isFirst, setIsFirst] = useState(true);

    useEffect(() => {
        if (materials && materials.length > 0 && materials[0].hasOwnProperty('transactions')) {
            if (isFirst == true && scrollableContainer.current) {
                scrollableContainer.current.scrollLeft += scrollableContainer.current.scrollHeight * 30;
                setIsFirst(false);
            }
        }
    }, [materials])

    return (
        <div className={'px-4'}>
            <div className="row mt-4 mb-2 justify-content-between">
                <div className="col-md-3">
                    <SearchForm getPageItems={getMaterialsTransactions}/>
                </div>
                {
                    role_name !== 'manager' && role_name !== 'storekeeper' ? (
                        <div className="col-md-2">
                            <FilterByFirm getPageItems={getMaterialsTransactions}/>
                        </div>
                    ) : ''
                }
                <div className="col-md-3 align-self-end ">
                    <FilterByMonth getPageItems={getMaterialsTransactions}/>
                </div>
            </div>

            <div className="row mt-3">

                <div className={`loader-container ${loading ? 'loading' : ''} `}></div>

                <div ref={scrollableContainer} className={`tableFixHead ${loading ? 'data_loader' : ''}`}>

                    {
                        materials && materials.length > 0 ? (
                            <table className={'table-hover custom-hover'}>
                                <thead>
                                <tr>
                                    <th className="sticky-col" style={{width: "2em"}}>#</th>
                                    <th className="sticky-col2">Material</th>
                                    {
                                        dates?.map((item, index, items) => (
                                            items.length - 1 === index ? (
                                                <th key={`date${index}`} className="sticky-col"
                                                    style={{textAlign: "center"}}
                                                    colSpan="2">
                                                    {item}
                                                    {moment(new Date()).format('YYYY-MM-DD') == item ? '(bugun)' : ''}
                                                </th>
                                            ) : (
                                                <th key={`date${index}`} className="sticky-col"
                                                    style={{textAlign: "center"}}
                                                    colSpan="2">{item}
                                                </th>
                                            )
                                        ))
                                    }
                                    <th className="sticky-col" style={{textAlign: "center", right: 0}}
                                        colSpan="4">Oy bo'yicha umumiy hisob
                                    </th>
                                </tr>
                                <tr>
                                    <th className="sticky-col">-</th>
                                    <th className="sticky-col2"></th>
                                    {
                                        dates.map((subitem, index) => (
                                            <Fragment key={`th${index}`}>
                                                <th className="sticky-col"
                                                    style={{textAlign: "center"}}>Import
                                                </th>
                                                <th className="sticky-col"
                                                    style={{textAlign: "center"}}>Sarf
                                                </th>
                                            </Fragment>
                                        ))
                                    }
                                    <th className="sticky-col"
                                        style={{textAlign: "center", minWidth: "100px", right: "300px"}}>
                                        O'tgan oy qoldig'i
                                    </th>
                                    <th className="sticky-col"
                                        style={{textAlign: "center", minWidth: "100px", right: "200px"}}>
                                        Umumiy import
                                    </th>
                                    <th className="sticky-col"
                                        style={{textAlign: "center", minWidth: "100px", right: "100px"}}>
                                        Umumiy sarfi
                                    </th>
                                    <th className="sticky-col"
                                        style={{textAlign: "center", minWidth: "100px", right: "0px"}}> Qoldiq
                                    </th>
                                </tr>
                                </thead>

                                <tbody>
                                {materials?.map((item, index) => (
                                    <MaterialDataRow item={item} key={item.id} index={index}
                                                     resetAllRows={resetAllRows}/>
                                ))}
                                </tbody>
                            </table>
                        ) : ''
                    }

                </div>

            </div>

            <div className="row mt-3">
                <CustomPagination
                    numberOfPages={numberOfPages}
                    getPageItems={getMaterialsTransactions}
                    current_page={current_page}
                />
            </div>
            <MaterialReport/>
        </div>

    )
}

MaterialCalculations.propTypes = {
    getMaterialsTransactions: PropTypes.func.isRequired,
    materials_transaction: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    materials_transaction: state.materials_transaction,
});

export default connect(mapStateToProps, {getMaterialsTransactions, updateTransaction})(MaterialCalculations);

